import { h, Component } from '@stencil/core';


@Component({
  tag: 'tip-info'
})
export class TipInfo {
  render() {
    let root = document.querySelector('tip-root');
    return (
      <ion-card>
        <ion-card-header>
          <ion-card-title>{root.siteTitle}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
        <p>The Transportation Improvement Program lists transportation projects
        anticipated to be constructed in the metropolitan planning area during
        the next four years. The program reflects the goals, objectives, and
        recommendations from the 25-year Long Range Transportation Plan in the
        short term.</p><br />
        <p>
        For more information, visit the <a href="https://ccrpc.org/tip">
        Transportation Improvement Program page</a>.
        </p>
        </ion-card-content>
      </ion-card>
    )
  }
}
